/* eslint-disable no-useless-escape */
const emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

/**
 * @param email email to validate
 * @returns boolean result of validation
 */
export const validateEmail = (email: string): boolean => {
  return emailRegex.test(email);
};
